import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/mini';
import { VaultWithdrawPage } from '../components/pages/VaultTransferPage/VaultWithdrawPage';

const searchSchema = z.object({
  vaultId: z.optional(z.string()),
  accountId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/vaults_/withdraw')({
  component: VaultWithdrawPage,
  validateSearch: searchSchema.parse,
});
